import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Picker, Item } from '@adobe/react-spectrum';

import actionWebInvoke from '../../../utils/actionCallUtils';
import actions from '../../../config.json';
import OBJCODE from '../../../constants';
import PageSectionDivider from '../../../components/Layout/Content/PageSectionDivider';

// TODO: Refactor to use a commom component
const Sponsors = ({ sponsors, setSponsors }) => {
  async function fetchSponsors() {
    setSponsors({ ...sponsors, isLoading: true });

    const fields = ['ID', 'name'];
    const queryParams = {};
    const list = await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.USER, queryParams, fields },
    );

    setSponsors({
      ...sponsors,
      elements: list,
      isLoading: false,
    });
  }

  async function selectClient(selected) {
    setSponsors({ ...sponsors, selected });
  }

  useEffect(() => {
    fetchSponsors();
  }, []);

  return (
    <div>
      <Picker
        label="Sponsor"
        onSelectionChange={selected => selectClient(selected)}
        defaultSelectedKey="Select Client..."
      >
        {sponsors.elements.slice(0).map(row => (
          <Item key={row.ID}>{row.name}</Item>
        ))}
      </Picker>
      <PageSectionDivider size="S" />
    </div>
  );
};

Sponsors.propTypes = {
  setSponsors: PropTypes.func.isRequired,
  sponsors: PropTypes.shape({
    isLoading: PropTypes.bool,
    selected: PropTypes.string,
    elements: PropTypes.arrayOf(
      PropTypes.shape({
        ID: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
  }).isRequired,
};

export default Sponsors;
